// @flow
export { default } from './CatalogsPage';
export { default as CatalogDetailsPage } from './CatalogDetailsPage';
export { default as CatalogIngestPage } from './CatalogIngestPage';
export { default as CatalogingOptionsForm } from './CatalogingOptionsForm';
export {
  default as CatalogManagedUploadForm,
} from './ManagedFields/CatalogManagedUploadForm';
export { default as CatalogPreviewsForm } from './CatalogPreviewsForm';
export {
  default as CatalogSmartKeywordsPage,
} from './CatalogSmartKeywordsPage';
export { default as CatalogUsersPage } from './CatalogUsersPage';
export { default as FieldsPage } from './FieldsPage';



// WEBPACK FOOTER //
// ./src/view/Pages/CatalogsPage/index.js